import { BehaviorSubject } from 'rxjs';

/**
 * Subject to store the user from the Digital Platform.
 */
const currentUser$$ = new BehaviorSubject(null);
// If the current user is an employee.
let _isEmployee = false;
// If the current user is a client.
let _isClient = false;
/**
 * Sets a given user.
 * @param candidate The user to set.
 * @returns void;
 */
function setUser(candidate) {
    _isClient = candidate.role === 'APR' || candidate.role === 'AT' || candidate.role === 'PR' || candidate.role === 'P' || candidate.role === 'SAT' || candidate.role === 'T';
    _isEmployee = candidate.role === 'A' || candidate.role === 'B';
    currentUser$$.next(candidate);
}
/**
 * Gets the current user.
 * @returns The current user as an Observable.
 */
function getUser$() {
    return currentUser$$.asObservable();
}
/**
 * Gets the current user.
 * @returns The current user Subject value.
 */
function getUser() {
    return currentUser$$.getValue();
}
/**
 * Returns if the current user is an employee.
 * @returns {Boolean} if the current user is an employee.
 */
function isEmployee() {
    return _isEmployee;
}
/**
 * Returns if the current user is a client.
 * @returns {Boolean} if the current user is a client.
 */
function isClient() {
    return _isClient;
}

var KnowledgeFseAccess;
(function (KnowledgeFseAccess) {
    KnowledgeFseAccess["FILTERTOMBSTONES"] = "FILTERTOMBSTONES";
    KnowledgeFseAccess["VISUALIZE"] = "VISUALIZE";
    KnowledgeFseAccess["DOWNLOAD"] = "DOWNLOAD";
    KnowledgeFseAccess["CREATECUSTOM"] = "CREATECUSTOM";
    KnowledgeFseAccess["DOWNLOADTOMBSTONES"] = "DOWNLOADTOMBSTONES";
    KnowledgeFseAccess["SEND"] = "SEND";
})(KnowledgeFseAccess || (KnowledgeFseAccess = {}));
var KnowledgeFseAccessTombstones;
(function (KnowledgeFseAccessTombstones) {
    KnowledgeFseAccessTombstones["FILTER"] = "FILTER";
    KnowledgeFseAccessTombstones["VIEW"] = "VIEW";
    KnowledgeFseAccessTombstones["DOWNLOAD"] = "DOWNLOAD";
    KnowledgeFseAccessTombstones["CREATECUSTOM"] = "CREATECUSTOM";
    KnowledgeFseAccessTombstones["DOWNLOADTOMBSTONES"] = "DOWNLOADTOMBSTONES";
    KnowledgeFseAccessTombstones["SEND"] = "SEND";
})(KnowledgeFseAccessTombstones || (KnowledgeFseAccessTombstones = {}));
var InternalOrExternalCommsFSE;
(function (InternalOrExternalCommsFSE) {
    InternalOrExternalCommsFSE["INTERNAL"] = "INTERNAL";
    InternalOrExternalCommsFSE["EXTERNAL"] = "EXTERNAL";
})(InternalOrExternalCommsFSE || (InternalOrExternalCommsFSE = {}));
var InternalCommsPermissionFSE;
(function (InternalCommsPermissionFSE) {
    InternalCommsPermissionFSE["CREATE"] = "CREATE";
    InternalCommsPermissionFSE["SIGN"] = "SIGN";
    InternalCommsPermissionFSE["ATTACH"] = "ATTACH";
    InternalCommsPermissionFSE["REPLY"] = "REPLY";
})(InternalCommsPermissionFSE || (InternalCommsPermissionFSE = {}));

/*
 * Public API Surface of auth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InternalCommsPermissionFSE, InternalOrExternalCommsFSE, KnowledgeFseAccess, KnowledgeFseAccessTombstones, getUser, getUser$, isClient, isEmployee, setUser };
